var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showChart)?_c('fusioncharts',{attrs:{"type":_vm.type,"width":_vm.width,"max-height":_vm.height,"dataformat":"json","dataSource":_vm.dataSource}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }